export enum ForecastTab {
  FORECAST = 'FORECAST',
  INSIGHTS = 'INSIGHTS',
  ANALYSIS = 'ANALYSIS',
  REPORTING = 'REPORTING',
}
